import { debug } from '@moleculeone/utils';

import { drawnMolTest } from '../checks';
import { getExplicitValences, getSmallestCycles } from '../selectors';
import { mdlModel } from '../chemistry/valence-model';
import { setColors } from './colors';
import { setAtomLabels } from './labels';
import { setLabelsLayout } from './layout';
import { setWarnings } from './warnings';
import { setBondLines } from './bonds';

export function initialDrawingData(mol) {
  const drawnMol = {
    atoms: {},
    bonds: {},
  };

  for (const [key, atom] of Object.entries(mol.atoms)) {
    drawnMol.atoms[key] = {
      idx: atom.idx,
      pos: mol.positions[atom.idx],
      data: {},
      warnings: [],
    };
  }
  for (const [key, bond] of Object.entries(mol.bonds)) {
    drawnMol.bonds[key] = {
      idx: bond.idx,
      start: bond.start,
      end: bond.end,
      data: {},
      warnings: [],
    };
  }
  if (mol.key != null) {
    drawnMol.key = mol.key;
  }

  const explicitValences = getExplicitValences(mol);
  for (const [key, drawnAtom] of Object.entries(drawnMol.atoms)) {
    const atom = mol.atoms[key];
    const explicitValence = explicitValences[atom.idx];
    const valence = mdlModel.valence(atom.element, atom.charge, explicitValence);
    const hydrogens = valence === null ? null : valence - explicitValence;
    drawnAtom.data.explicitValence = explicitValence;
    drawnAtom.data.valence = valence;
    drawnAtom.data.hydrogens = hydrogens;
  }

  const { bondToCycle } = getSmallestCycles(mol);
  for (const [key, cycle] of Object.entries(bondToCycle)) {
    drawnMol.bonds[key].data.cycle = cycle;
  }

  return drawnMol;
}

export function standardDrawing(mol, selected = []) {
  try {
    const drawnMol = initialDrawingData(mol);
    setAtomLabels(mol, drawnMol);
    setBondLines(mol, drawnMol);
    setLabelsLayout(mol, drawnMol);
    setColors(mol, drawnMol, undefined, selected);
    setWarnings(mol, drawnMol);
    return debug(drawnMolTest, drawnMol);
  } catch (error) {
    throw new Error(error.message);
  }
}
